// Plain <img> (not next/image — this is Create React App, not Next.js) and
// inline styles (not Tailwind — this codebase doesn't use it) so it matches
// how every other component here is written.
export default function BrandLogo({ showName = true, size = 42 }) {
  return (
    <span style={wrap}>
      {/* The name text next to it already gives this an accessible name —
          alt="" here stops screen readers announcing "GatherYou" twice.
          When the icon appears alone (showName=false) it needs its own alt. */}
      <img
        src="/brand/logo-mark.png"
        alt={showName ? "" : "GatherYou.in"}
        width={size}
        height={size}
        style={imgStyle}
      />
      {showName && <span style={nameStyle}>GatherYou.in</span>}
    </span>
  );
}

const wrap = {
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
};

const imgStyle = {
  display: "block",
  objectFit: "contain",
  borderRadius: 8,
};

const nameStyle = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: 26,
  fontWeight: 700,
  letterSpacing: "-0.02em",
  // Was a hardcoded orange gradient (a leftover from before the rebrand to
  // GatherYou) that didn't respond to dark mode and didn't match either
  // the app's own accent tokens or the navy-and-gold logo mark next to it.
  color: "var(--accent-primary)",
  backgroundImage: "linear-gradient(135deg, var(--accent-primary) 0%, var(--accent-gold) 50%, var(--accent-primary) 100%)",
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  WebkitTextFillColor: "transparent",
};
